var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menuItems)?_c('div',[_c('div',{on:{"click":_vm.addNewItem}},[_vm._v("add item aaa")]),_vm._v("\n  ddl-multiple"),_c('br'),_vm._v(" "),_c('vue-nestable',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return _c('vue-nestable-handle',{attrs:{"item":item}},[_vm._v("\n      "+_vm._s(item.text)+"\n    ")])}}]),model:{value:(_vm.menuItemsLocal),callback:function ($$v) {_vm.menuItemsLocal=$$v},expression:"menuItemsLocal"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79d86cc9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Custom/MenuItem/menuItem.vue
// module id = null
// module chunks = 